import {api_booking} from "./api.booking";
import {api_notifications} from "./api.notifications";

export const API_MedCenter = {
    booking: api_booking,
    notifications: api_notifications
}